<el-dropdown class="relative">
  <button
    class="w-full inline-flex items-center gap-x-3 rounded-md px-2.5 py-1.5 text-sm bg-white dark:bg-gray-900/50 outline-1 -outline-offset-1 outline-gray-300 dark:outline-gray-900 focus:outline-2 focus:-outline-offset-2 justify-between text-left cursor-pointer"
  >
    <span class="truncate">{{ displayValue() }}</span>

    <svg
      viewBox="0 -960 960 960"
      fill="currentColor"
      data-slot="icon"
      aria-hidden="true"
      class="-mr-0.5 size-4"
    >
      <path
        d="M480-96 252-324l51-51 177 177 177-177 51 51L480-96ZM303-585l-51-51 228-228 228 228-51 51-177-177-177 177Z"
      />
    </svg>
  </button>

  <el-menu
    anchor="bottom end"
    popover
    class="w-(--button-width) origin-top-right border border-solid border-gray-100 rounded-md shadow-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 outline-1 -outline-offset-1 outline-white/10 transition transition-discrete [--anchor-gap:--spacing(2)] data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
  >
    <div class="py-1 max-h-42 w-full overflow-y-auto!">
      @if (allItemsLabel()) {
        <button
          type="button"
          (click)="select($event, '-all-items-')"
          class="flex w-full justify-between px-4 py-2 text-sm focus:text-gray-600 dark:focus:text-gray-300 focus:outline-hidden cursor-pointer"
        >
          <span class="text-left">{{ allItemsLabel() }}</span>

          <svg
            viewBox="0 -960 960 960"
            class="h-5 w-5 fill-primary-500"
            [class.hidden]="value().length"
            aria-hidden="true"
          >
            <path d="M400-301 240-461l51-51 109 109 269-269 51 51-320 320Z" />
          </svg>
        </button>
      }

      @for (option of displayOptions(); track option.value) {
        <button
          type="button"
          (click)="select($event, option.value, option.disabled)"
          class="flex w-full justify-between px-4 py-2 text-sm focus:text-gray-600 dark:focus:text-gray-300 focus:outline-hidden cursor-pointer"
        >
          <span class="text-left truncate" [class.disabled]="option.disabled">{{
            option.label
          }}</span>

          <svg
            viewBox="0 -960 960 960"
            class="h-5 w-5 fill-primary-500"
            [class.hidden]="!option.selected"
            aria-hidden="true"
          >
            <path d="M400-301 240-461l51-51 109 109 269-269 51 51-320 320Z" />
          </svg>
        </button>
      }
    </div>
  </el-menu>
</el-dropdown>
